module.exports = __webpack_public_path__ + "static/img/infoChangeAuth.d490782d.jpg";